import { CASES, OPERATORS, ORDERS, SearchCase, SearchOperator, SearchOrder } from "../Types/search.types";

export const SearchHelper = {
    allCases: Object.values(CASES),

    allOperators: Object.values(OPERATORS),

    allOrders: Object.values(ORDERS),


    isValidCase: (value: string): boolean =>
        Object.values(CASES).includes(value as SearchCase),


    isValidOperator: (value: string): boolean =>
        Object.values(OPERATORS).includes(value as SearchOperator),

    isValidOrder: (value: string): boolean =>
        Object.values(ORDERS).includes(value as SearchOrder),

    isSensitive : (value : SearchCase) : boolean => value === CASES.SENSITIVE,

    isInSensitive : (value : SearchCase) : boolean => value === CASES.INSENSITIVE,

    isEqualsSearch : (value : SearchOperator) : boolean => value === OPERATORS.EQUALS,

    isContainsSearch : (value : SearchOperator) : boolean => value === OPERATORS.CONTAINS,

    isASC : (value : SearchOrder) : boolean => value === ORDERS.ASC,

    isDESC : (value : SearchOrder) : boolean => value === ORDERS.DESC,

};
